






















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { afterDetail, operationLog } from '@/utils/api';
import logistics from './components/logistics.vue';
@Component
export default class afterSale_detail extends Vue {
  tableData2: Array<object> = [];
  customerInfo: object = {};
  afterInfo: object = {};
  fileList: Array<object> = [];
  refundAddress: object = {};
  refundLogistics: object = {};
  operationLogList: Array<object> = [];
  deliverLogistics: object = {};
  receiveAddress: object = {};
  dialogFormVisible1: boolean = false;
  created() {}
  mounted() {
    this.afterDetail();
    this.operationLog();
  }
  // 返回售后单列表
  goBack() {
    this.$router.push('afterSale_list');
  }
  // 详情数据
  afterDetail() {
    afterDetail({ code: this.$route.query.code })
      .then(res => {
        if (res) {
          for (const key in res) {
            if (res[key] == null) {
              res[key] = {};
            }
          }
          this.tableData2 = [res.aftersaleOrder];
          this.customerInfo = res.customerInfo;
          this.afterInfo = res.aftersaleOrder;
          this.fileList = res.fileList;
          this.refundAddress = res.refundAddress;
          this.refundLogistics = res.refundLogistics;
          this.deliverLogistics = res.deliverLogistics;
          this.receiveAddress = res.receiveAddress;
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
  // 操作日志
  operationLog() {
    operationLog({ code: this.$route.query.code })
      .then(res => {
        if (res) {
          this.operationLogList = res;
        }
      })
      .catch(err => {
        console.log(err);
        this.$message.error(err);
      });
  }
}
